export const RP_GAS_PERFORMANCE_MODEL_LIST = 'RP_GAS_PERFORMANCE_MODEL_LIST'
export const RP_GAS_PERFORMANCE_SEARCH = 'RP_GAS_PERFORMANCE_SEARCH'
export const RP_GAS_PERFORMANCE_PAGINATION = 'RP_GAS_PERFORMANCE_PAGINATION'
export const RP_GAS_PERFORMANCE_DROP_DOWN_SEARCH_YEAR = 'RP_GAS_PERFORMANCE_DROP_DOWN_SEARCH_YEAR'
